import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const Item = (props) => {
  if (props.active) {
    return (
      <span className={props.className}>
        {props.renderSeparator ? <span>|</span> : ''}
        <span className="itemWithoutLink">{props.children}</span>
      </span>
    );
  }

  return (
    <span className={props.className}>
      {props.renderSeparator ? <span>|</span> : ''}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          props.onOptionSelected();
        }}
      >
        {props.children}
      </a>
    </span>
  );
};

Item.propTypes = {
  active: PropTypes.bool,
  renderSeparator: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onOptionSelected: PropTypes.func,
  className: PropTypes.string
};

Item.defaultProps = {
  active: false,
  renderSeparator: true,
  onOptionSelected: () => {},
  className: ''
};

const Wrapper = styled.div`
  display: inline;
  font-size: 14px;
  line-height: 21px;
`;

const StyledItem = styled(Item)`

  > a {
    padding: 0 5px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.purple};
  }

  > a:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary.purpleHover};
  }

  > .itemWithoutLink {
    padding: 0 5px;
  }
`;

const LabelEndMobile = styled.span`
  ${({ theme }) => css`
    @media ${theme.breakpoints.desktop} {
      display: none;
    }
  `};
`;

const LabelEndDesktop = styled.span`
  display: none;

  ${({ theme }) => css`
    @media ${theme.breakpoints.desktop} {
      display: inline;
    }
  `};
`;

/**
 * @tags styled, pagination
 */
const ItemsPerPage = (props) => {

  if (props.itemsCount <= props.options[0]) {
    return <noscript />;
  }

  const displayedOptions = props.options.filter(option => option < props.itemsCount);

  return (
    <Wrapper className={props.className} data-qa={props.qa}>
      {props.showLabelStart}
      {displayedOptions.map((option, index) => (
        <StyledItem
          key={index}
          active={option === props.activeOption}
          renderSeparator={index > 0}
          onOptionSelected={() => {
            props.onOptionSelected(option);
          }}
        >
          {option}
        </StyledItem>
      ))}
      {props.options.length > displayedOptions.length &&
        (
          <StyledItem
            active={props.itemsCount === props.activeOption}
            onOptionSelected={() => props.onOptionSelected(props.itemsCount)}
          >
            {props.allLinkLabel}
          </StyledItem>
        )}
      <LabelEndMobile>{props.showLabelEndMobile}</LabelEndMobile>
      <LabelEndDesktop>{props.showLabelEnd}</LabelEndDesktop>
    </Wrapper>
  );

};

ItemsPerPage.displayName = 'ItemsPerPage';

ItemsPerPage.propTypes = {
  className: PropTypes.string,
  itemsCount: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  activeOption: PropTypes.number.isRequired,
  onOptionSelected: PropTypes.func,
  showLabelStart: PropTypes.string,
  showLabelEnd: PropTypes.string,
  showLabelEndMobile: PropTypes.string,
  allLinkLabel: PropTypes.string,
  qa: PropTypes.string
};

ItemsPerPage.defaultProps = {
  className: undefined,
  onOptionSelected: () => {},
  showLabelStart: 'Show',
  showLabelEnd: 'items per page',
  showLabelEndMobile: 'items',
  allLinkLabel: 'All',
  qa: undefined
};

/** @component */
export default ItemsPerPage;
